import useShallowEqualSelector from '../../../custom_hooks/useShallowEqualsSelector';
import { ReducerKeys } from '../../../redux/reducers';
import { StateStatus } from '../../utils/common';
import * as NotificationService from 'services/api/notification';

interface NotificationListElement {
  notification_id: number;
  applicant_id: number;
  notification_type: string;
  notification_title: string;
  notification_message: string;
  is_read: number;
  created_by: string;
  created_at: string;
  modified_by: string;
  modified_at: string;
}

interface NotificationListData {
  paging: NotificationListPaging;
  items: NotificationListElement[];
}

interface NotificationListPaging {
  page: number;
  pageSize: number;
  total: number;
}

interface NotificationistOutput {
  status: StateStatus;
  data: NotificationListData | null;
}

export const useGetNotificationList = (): NotificationistOutput => {
  const data = useShallowEqualSelector(
    (state: any) => state[ReducerKeys.NOTIFICATION_REDUCER].NotificationList
  );
  return data;
};

export interface ReminderOutput {
  status: StateStatus;
  data: NotificationService.ReminderListData | null;
}

export const useGetReminderList = (): ReminderOutput => {
  const data = useShallowEqualSelector(
    (state: any) => state[ReducerKeys.NOTIFICATION_REDUCER].ReminderList
  );
  return data;
};

export const useGetUnreadNotificationCount = (): number => {
  const data = useShallowEqualSelector(
    (state: any) =>
      state[ReducerKeys.NOTIFICATION_REDUCER].unreadNotificationCount.data
  );
  return data;
};
